import { EAnticipationStatus } from 'interfaces/IUser';

import type IUser from 'interfaces/IUser';

class User implements IUser {
  id: string;
  name: string;
  full_name: string;
  business_name: string;
  producer: boolean;
  show_legal_person_card: boolean;
  affiliate: boolean;
  coproducer: boolean;
  email: string;
  beta_customer: boolean;
  tours: any;
  type: string;
  photo: string;
  eadCharging: boolean;
  newbie: boolean;
  is_support: boolean;
  support_id: number;
  is_elite: boolean;
  is_clube_black: boolean;
  has_launch_export: boolean;
  has_transfer: boolean;
  document: string;
  partial_refund: string;
  coupom_batch: string;
  crossborder: boolean;
  invoice_transfer: boolean;
  current_elite_level: any;
  has_chat_black: boolean;
  not_recovering: number;
  new_anticipation_transfer: boolean;
  subscription_physical: boolean;
  fiscal_responsibility: boolean;
  general_term: boolean;
  acceptence_terms: boolean;
  anticipation_status: EAnticipationStatus;
  anticipation_status_message: string;
  negociate_invoice: boolean;
  create_new_account_bank: boolean;
  overdue_limit: boolean;
  international_account: boolean;
  eligible: boolean;

  constructor(private user: IUser) {
    this.id = this.user.id || '';
    this.name = this.user.name || '';
    this.full_name = this.user.full_name || '';
    this.business_name = this.user.business_name || '';
    this.producer = this.user.producer || false;
    this.affiliate = this.user.affiliate || false;
    this.coproducer = this.user.coproducer || false;
    this.show_legal_person_card = this.user.show_legal_person_card || false;
    this.email = this.user.email || '';
    this.beta_customer = this.user.beta_customer || false;
    this.type = this.user.type || '';
    this.photo = this.user.photo || '';
    this.eadCharging = this.user.eadCharging || false;
    this.is_support = this.user.is_support || false;
    this.support_id = this.user.support_id || 0;
    this.is_elite = this.user.is_elite || false;
    this.is_clube_black = this.user.is_clube_black || false;
    this.has_transfer = this.user.has_transfer || false;
    this.document = this.user.document || '';
    this.partial_refund = this.user.partial_refund || '';
    this.coupom_batch = this.user.coupom_batch || '';
    this.crossborder = this.user.crossborder || false;
    this.invoice_transfer = this.user.invoice_transfer || false;
    this.has_launch_export = this.user.has_launch_export || false;
    this.current_elite_level = this.user.current_elite_level || false;
    this.has_chat_black = this.user.has_chat_black || false;
    this.not_recovering = this.user.not_recovering || 0;
    this.new_anticipation_transfer = this.user.new_anticipation_transfer || false;
    this.subscription_physical = this.user.subscription_physical || false;
    this.newbie = this.user.newbie || false;
    this.fiscal_responsibility = this.user.fiscal_responsibility || false;
    this.general_term = this.user.general_term || false;
    this.acceptence_terms = this.user.acceptence_terms || false;
    this.anticipation_status = this.user.anticipation_status || EAnticipationStatus.LIBERADO;
    this.anticipation_status_message = this.user.anticipation_status_message || '';
    this.negociate_invoice = this.user.negociate_invoice || false;
    this.create_new_account_bank = this.create_new_account_bank || true;
    this.overdue_limit = this.user.overdue_limit || false;
    this.international_account = this.user.international_account || false;
    this.eligible = this.user.eligible || false;
  }

  isProducer() {
    return this.producer;
  }

  isAffiliate() {
    return this.affiliate;
  }

  isCustomer() {
    return this.beta_customer;
  }

  isCoproducer() {
    return this.coproducer;
  }
}

export default User;
